module.exports = __webpack_public_path__ + "static/media/monoful-logo-background-white.8b59acf0.svg";